import React from 'react';
import { FileText, MessageSquare, Scale, CheckCircle } from 'lucide-react';

const ProcessSteps = () => {
  const steps = [
    {
      icon: MessageSquare,
      title: 'Консультація',
      description: 'Ви описуєте ситуацію, ми аналізуємо та надаємо первинну оцінку справи'
    },
    {
      icon: FileText,
      title: 'Аналіз документів',
      description: 'Детальне вивчення всіх матеріалів та підготовка стратегії захисту'
    },
    {
      icon: Scale,
      title: 'Робота зі справою',
      description: 'Представництво ваших інтересів, ведення переговорів або судового процесу'
    },
    {
      icon: CheckCircle,
      title: 'Результат',
      description: 'Досягнення мети та повне інформування про всі етапи роботи'
    }
  ];

  return (
    <section className="section-container section-alt">
      <div className="content-wrapper">
        <h2 className="section-title">Процес співпраці</h2>
        <div className="process-grid">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="process-step">
                <div className="process-number">{index + 1}</div>
                <div className="process-icon">
                  <Icon size={32} />
                </div>
                <h3 className="process-title">{step.title}</h3>
                <p className="process-description">{step.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;